import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const actions = {
    async storeEwallet({ commit, dispatch }, ewalletData) {
        let route = Laroute.route('franchise.setting.ewallet.store');

        startLoading(dispatch, 'save-ewallet');

        return await axios
            .post(route, ewalletData)
            .then(res => {
                endLoading(dispatch, 'save-ewallet');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-ewallet');
                throw err;
            });
    },

    async updateEwallet({ commit, dispatch }, ewalletData) {
        startLoading(dispatch, 'save-ewallet');

        return await axios
            .patch(
                Laroute.route('franchise.setting.ewallet.update', {
                    id: ewalletData.id,
                }),
                ewalletData,
            )
            .then(res => {
                endLoading(dispatch, 'save-ewallet');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-ewallet');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/ewallet.js